import { NavLink } from "react-router-dom";
import { Column, Grid } from "@carbon/react";

export const View = ({ pageTabNavLinks, search }) => {
  return (
    <>
      {/* Display side-by-side tabs for lg screens */}
      <Column lg={16} md={8} sm={0} className="page-tab--links">
        {pageTabNavLinks.map((link) => (
          <NavLink
            key={link.route}
            to={`${link.route}${search}`}
            className="page-tab--nav-link"
          >
            <span
              /* className="link-name"*/ style={{ display: "inline-block" }}
            >
              {link.name}
            </span>
          </NavLink>
        ))}
      </Column>

     
             
    </>
  );
};
